// utils/fileDownload.ts
export function saveBlobAsFile(
  res: { data: Blob; headers: Record<string, unknown> },
  defaultFilename: string
) {
  const blob = res.data;

  if (!blob || blob.size === 0) {
    throw new Error('Downloaded file is empty.');
  }

  // Try to get filename from content-disposition header
  const contentDisposition = res.headers['content-disposition'];
  let filename = defaultFilename;

  if (typeof contentDisposition === 'string') {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) filename = match[1];
  }

  // Create download link
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
